const data = require.context('./../modules/', true, /\.data\.js$/);
let dataArr = [];
let obj = {};
data.keys().forEach(key => {
    dataArr = dataArr.concat(data(key).default)
    obj = Object.assign(...dataArr)
})
export default  obj